import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { getKeywordPairStory } from "../../../../api/specialization/KeywordSpecializationAPI";
import { Grid, Popover } from "@mui/material";
type KeywordPairProps = {
  keyword: string;
  adjacentKeyword: string;
  days: number;
  open: any;
  onClose: any;
};

export function KeywordPairPopup(props: KeywordPairProps) {
  const { t } = useTranslation(["common", "keyword", "sidebar"]);

  useEffect(() => {
    getKeywordPairStory(props.keyword, props.adjacentKeyword, props.days)
      .then((res) => {
        console.log(res);
      })
      .catch(() => {});
  });

  return (
    <Popover
      open={props.open}
      onClose={props.onClose}
      anchorOrigin={{
        vertical: "center",
        horizontal: "right",
      }}
      sx={{
        marginTop: "25px",
        minWidth: "70vw",
        minHeight: "100vh",
      }}
    >
      <Grid container className="white" xs={12} spacing={2} marginTop={1.5}>
        HELLO
      </Grid>
    </Popover>
  );
}
